import { render } from "./CustomerList.vue?vue&type=template&id=16ebed1a&scoped=true&ts=true"
import script from "./CustomerList.vue?vue&type=script&lang=ts"
export * from "./CustomerList.vue?vue&type=script&lang=ts"

import "./CustomerList.vue?vue&type=style&index=0&id=16ebed1a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16ebed1a"]])

export default __exports__